import { isHideSeekRoundPlayer, isHnsPlayerDisqualified } from './player';
/**
 * Check if a player is eligible for Marco Polo (active hider, not caught, not DQ'd)
 * This is Hide and Seek (and Hide and Seek Teams) functionality.
 */
export function isEligibleForMarcoPolo(roundPlayer) {
    // Must be a Hide and Seek round player
    if (!isHideSeekRoundPlayer(roundPlayer)) {
        return false;
    }
    // Must be a hider (original role)
    const originalRole = roundPlayer.originalRole || roundPlayer.role;
    if (originalRole !== 'hider') {
        return false;
    }
    // Must not be caught (capturedAt: they became a seeker, or are out)
    if (roundPlayer.capturedAt) {
        return false;
    }
    // Must not be disqualified
    if (isHnsPlayerDisqualified(roundPlayer)) {
        return false;
    }
    return true;
}
